const { useEffect, useRef } = require("react");


export const FormRedirect = (props) => {
  const formEl = useRef(null);

  useEffect(() => {
    setTimeout(() => {
      if (formEl) {
        formEl.current.submit();
      }
    }, 500);
  }, []);


  return <form method="POST" action={props.redirect_url}
    ref={formEl}
  >
    <input type="hidden" name={"token"} value={props.token} />
    <input type="hidden" name={"redirect_app_url"} value={props.redirect_app_url} />
    {props.redirect_err_url && <input type="hidden" name={"redirect_err_url"} value={props.redirect_err_url} />}
  </form>
};